import styled from 'styled-components';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import React from 'react';
import FdrFlightSectionShort from 'fdr/components/local/fdr-flight-section/fdr-flight-section-short';
import {
  FdrProductCardImageWrap,
  FdrProductCardTravelType,
} from 'fdr/components/local/fdr-product-card/fdr-product-card.styles';
import { COMPARE_ITEMS_COUNT_DESKTOP } from './fdr-wishlist.constants';
import FdrWishlistItemOverlay, {
  IFdrWishlistItemOverlay,
} from './fdr-wishlist-item-overlay';

export const WishlistCompareItemsDesktopWrapper = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    mx: -3,
    flex: 1,
    mb: [5, 6],
    position: 'relative',
    flexDirection: 'column',
  })
);

export const SelectedItemsWrapper = styled.div({
  display: 'flex',
});

export const CardWrapper = styled.div(({ theme: { FONT_SIZE, radii } }) =>
  sx2CssThemeFn({
    width: `calc(${100 / 3}% - 32px)`,
    position: 'relative',
    backgroundColor: 'background',
    borderTop: '1px solid',
    borderColor: 'borderColor',
    transition: 'slow',
    display: 'flex',
    flexDirection: 'column',
    mx: 3,
    p: 3,
    '.card-trip-advisor': {
      '.tripAdvisorInfoText': {
        '@media screen and (max-width: 1140px)': {
          fontSize: '16px',
          lineHeight: '24px',
        },
        ...FONT_SIZE.MEDIUM,
        pt: 2,
      },
      '.icon': {
        variant: 'icons.md',
        '@media screen and (max-width: 1140px)': {
          variant: 'icons.sm',
        },
      },
      '.tripAdvisorInfoNumber': {
        fontWeight: 'bold',
      },
    },
    '.card-book-button': {
      mx: 3,
      borderRadius: radii.default,
    },
  })
);

export const CardPriceWrapper = styled(CardWrapper)({
  paddingBottom: '8px',
});

export const CardFeaturesWrapper = styled(CardWrapper)({
  borderTop: 'none',
  paddingTop: '0px',
});

export const CardCtaWrapper = styled(CardWrapper)(({ theme: { space } }) => ({
  padding: space[0],
  border: 'none',
  borderRadius: '0px 0px 4px 4px',
}));

export const WishlistORLLinkContainer = styled.div(
  ({ theme: { FONT_SIZE, colors } }) =>
    sx2CssThemeFn({
      ...FONT_SIZE.LINK_LARGE,
      p: 3,
      textAlign: 'center',
      a: {
        '.icon': {
          verticalAlign: 'middle',
          ml: 2,
          width: '16px',
          height: '16px',
          flexShrink: 0,
        },
        textDecoration: 'underline',
        textDecorationColor: colors.linkUnderlineColor,
        textUnderlineOffset: '6px',
        '&:hover,&:focus': {
          color: colors.defaultText,
          textDecorationColor: colors.defaultText,
        },
      },
    })
);

export const PriceWrapper = styled.div(({ theme: { FONT_SIZE } }) =>
  sx2CssThemeFn({
    textAlign: 'end',
    bg: 'bgLightBlue',
    py: 1,
    px: 2,
    mb: 2,
    '.price': {
      ...FONT_SIZE.XS,
      ml: 1,
    },
  })
);

export const TravelTypeWrapper = styled.div.attrs({
  className: 'travelType',
})(({ theme: { space, radii } }) => ({
  position: 'absolute',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  margin: space[0],
  right: 'auto',
  top: space[2],
  left: space[2],
  '.topOffer': {
    padding: `${space[1]} ${space[2]}`,
    borderRadius: radii.default,
    position: 'relative',
    right: 'auto',
    left: space[2],
  },
  '@media screen and (max-width: 1220px)': {
    flexDirection: 'column',
    '.topOffer': {
      alignSelf: 'flex-start',
      marginTop: space[2],
      position: 'initial',
      left: space[5],
    },
  },
}));

export const WishlistProductTravelType = styled(FdrProductCardTravelType)(
  sx2CssThemeFn(({ theme: { radii, space } }) => ({
    borderRadius: radii.default,
    padding: `${space[1]} ${space[2]}`,
    '.icon': {
      marginRight: '3px',
    },
    '.delimiter': {
      px: '3px',
    },
  }))
);

export const TravelTypeIconWrapper = styled.span(({ theme: { space } }) => ({
  display: 'flex',
  alignItems: 'center',
  '.travel-type-icon': {
    verticalAlign: 'sub',
    marginRight: space[1],
  },
}));

export const WishlistImageWrapper = styled(FdrProductCardImageWrap)(
  sx2CssThemeFn({
    height: '137px',
    minHeight: '137px',
    flexBasis: '137px',
    cursor: 'pointer',
    m: -3,
    mb: 0,
  })
);

export const WishlistRatingCardWrapper = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    p: '3',
    m: -3,
    mt: 0,
    flexDirection: 'column',
    '.cardTitle': {
      lineHeight: '1.3',
    },
    '.cardSubTitle': {
      mt: 2,
      mb: 0,
    },
  })
);

export const RatingWrapper = styled.div({
  display: 'flex',
  position: 'relative',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const SectionHeader = styled.p(({ theme, theme: { FONT_SIZE } }) =>
  sx2CssThemeFn({
    display: 'flex',
    alignItems: 'center',
    ...FONT_SIZE.LARGE_BOLD,
    marginBottom: 3,
    '.wishlist-card-flight-icon': {
      ...theme.icons.lg,
      marginRight: 2,
    },
  })
);

export const DateWrapper = styled.div(({ theme: { space } }) => ({
  marginBottom: space[3],
}));

export const FlightSectionShortWrapper = styled(FdrFlightSectionShort)(
  ({ theme: { space } }) => ({
    marginBottom: space[3],
  })
);

export const RoomsWrapper = styled.div(
  ({ theme: { space, colors, FONT_SIZE } }) =>
    sx2CssThemeFn({
      '&:not(:last-child)': {
        marginBottom: space[3],
      },
      '.wishlist-rooms': {
        marginBottom: space[2],
        color: colors.darkGray,
      },
      '.wishlist-rooms-description': FONT_SIZE.MEDIUM,
    })
);

export const RoomTypesWrapper = styled.ul(({ theme: { FONT_SIZE, colors } }) =>
  sx2CssThemeFn({
    display: 'flex',
    textTransform: 'capitalize',
    flexWrap: 'wrap',
    ...FONT_SIZE.MEDIUM,
    color: colors.secondary,
    '.room-type': {
      marginRight: 2,
    },
  })
);

export const WishlistCompareItemFeaturesWrapper = styled.div(
  sx2CssThemeFn({
    mx: -3,
    my: 3,
    mt: 0,
  })
);

export const IncludedInPriceWrapper = styled.div(
  ({ theme: { space, fontSizes } }) => ({
    marginBottom: space[3],
    '.included-in-price-text-block': {
      ul: {
        listStyle: 'disc',
        paddingLeft: space[3],
        fontSize: fontSizes[2],
      },
    },
  })
);

export const IncludedInPriceHeader = styled.h1(
  sx2CssThemeFn({
    pt: 3,
    mt: -3,
    borderTop: '1px solid',
    borderColor: 'lightGreyFirst',
    mb: 3,
    fontSize: 2,
    '.icon': {
      mr: '10px',
      width: '16px',
      height: '16px',
    },
  })
);

export const TripAdvisorWrapper = styled.div(
  sx2CssThemeFn({
    pt: 3,
    mt: -3,
    borderTop: '1px solid',
    borderColor: 'lightGreyFirst',
  })
);

export const TransferInfoWrapper = styled.div({
  display: 'flex',
  flexGrow: 1,
  alignItems: 'center',
  '.icon': {
    marginRight: '10px',
    width: '16px',
    height: '16px',
  },
});

export const WishlistItemOverlayWrapper = styled(FdrWishlistItemOverlay)<{
  index: number;
}>(({ index }) =>
  sx2CssThemeFn({
    mx: 3,
    left: `calc(${(index / 3) * 100}% - 3px)`,
    right: `calc(${
      ((COMPARE_ITEMS_COUNT_DESKTOP - (index + 1)) / 3) * 100
    }% - 3px)`,
    '.flights': {
      flexDirection: 'column',
    },
  })
) as React.FC<IFdrWishlistItemOverlay & { index: number }>;
